import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "./index.css";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const pageNumPerPage = useRef(5);
  const indexOfLastPageNum = pageNumPerPage.current * props.currentPageNum;
  const indexOfCurrentPageNum = indexOfLastPageNum - pageNumPerPage.current;
  const currentNumberList = props.pageNumber?.slice(
    indexOfCurrentPageNum,
    indexOfLastPageNum
  );

  const prevHandler = (page) => {
    const newPage = page - 1;
    if (newPage <= indexOfCurrentPageNum) {
      props.setCurrentPageNum((prev) => prev - 1);
    }
    props.setCurrentPage(newPage);
  };
  const nextHandler = (page) => {
    const newPage = page + 1;
    if (newPage > indexOfLastPageNum) {
      props.setCurrentPageNum((prev) => prev + 1);
    }
    props.setCurrentPage(newPage);
  };
  const currentPageHandler = (page) => {
    props.setCurrentPage(page);
  };

  const changeHandler = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      const { value } = e.target;
      props.setGoTo(value);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const numberGoTo = Number(props.goTo);
    if (numberGoTo > props.pageNumber?.length) {
      props.setCurrentPage(props.pageNumber?.length);
      props.setCurrentPageNum(
        Math.ceil(props.pageNumber?.length / pageNumPerPage.current)
      );
      return;
    } else if (numberGoTo < 1) {
      props.setCurrentPage(1);
      props.setCurrentPageNum(1);
      return;
    }

    const numPageCurrent = Math.ceil(numberGoTo / pageNumPerPage.current);
    props.setCurrentPageNum(numPageCurrent);
    props.setCurrentPage(Number(props.goTo));
  };
  // Pagination for Messages Part End

  return (
    <Modal
      show={true}
      contentLabel="Example Modal"
      size={props.size || "xl"}
      className={props.modalClass || ""}
      aria-labelledby="contained-modal-title-vcenter"
      centered={props.center ? props.center : false}
    >
      <Modal.Header>
        <Modal.Title>{props.label}</Modal.Title>
        <button
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={props.showHide}
        >
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      {props.pagination &&
      <div className="container mb-5">
        <div className="row mx-5">
          {/* Page of Number */}
          <div className="col mt-2">
            {props.currentPage} of {props.pageNumber?.length} Pages
          </div>
 
            <div className="col d-flex gap-2 justify-content-center">
              {props.save ? <button className="btn btn-primary" onClick={props.handleSave}>{props.saveName ? props.saveName : ''}</button> : ''}
              {props.close ? <button className="btn btn-outline-primary" onClick={props.showHide}>{props.closeName ? props.closeName : ''}</button> : ''}
            </div>
          
          {/* Pages Box with Search Page Form */}
          <div className="col d-flex gap-3 justify-content-end">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item">
                  <button
                    class="page-link text-dark"
                    href="#"
                    disabled={props.currentPage === 1}
                    onClick={() => prevHandler(props.currentPage)}
                  >
                    Previous
                  </button>
                </li>
                {currentNumberList?.map((pgNum) => {
                  return (
                    <li class="page-item">
                      <button
                        className={`page-link text-dark ${
                          pgNum === props.currentPage
                            ? "paginationPageColor"
                            : ""
                        }`}
                        onClick={() => currentPageHandler(pgNum)}
                      >
                        {pgNum}
                      </button>
                    </li>
                  );
                })}

                <li class="page-item">
                  <button
                    class="page-link text-dark"
                    disabled={props.currentPage === props.pageNumber?.length}
                    onClick={() => nextHandler(props.currentPage)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
            {/* <form className="d-flex gap-1">
              <input
                className="paginationInputSearchBox text-center"
                type={"text"}
                name={"goto"}
                value={props.goTo}
                onChange={changeHandler}
              />
              <button
                className="rounded-3 PaginationBtn"
                onClick={submitHandler}
              >
                Go
              </button>
            </form> */}
          </div>
        </div>
      </div>
    }
    </Modal>
  );
};
